/*
 * IMPORTANT NOTICE!!
 *  Everytime someone changes this file, tell @masipcat to update this in the api as well.
 *  This is used to build the sitemap!
 *
 *  Important: This file is duplicated in front repo
 */

export default {
  '/vi/es/cha': {
    de: '/champagner',
    default: '/champagne',
  },
  '/vi/es/cav': {
    default: '/cava',
  },
  '/de/lh': {
    de: '/krauterlikor',
    en: '/herb-liqueur',
    es: '/licor-de-hierbas',
    fr: '/liqueur-aux-herbes',
    it: '/liquori-alle-erbe',
  },
  '/de/cc': {
    default: '/cachaca',
  },
  '/de/pi': {
    default: '/pisco',
  },
  '/de/pa': {
    default: '/pacharan',
  },
  '/de/bo': {
    default: '/bourbon',
  },
  '/de/ws': {
    default: '/whisky-single-malt',
  },
  '/de/ca': {
    default: '/calvados',
  },
  '/de/te': {
    default: '/tequila',
  },
  '/de/vo': {
    default: '/vodka',
  },
  '/de/gr': {
    default: '/grappa',
  },
  '/de/mc': {
    default: '/marc-de-cava',
  },
  '/de/wb': {
    default: '/whisky-blended',
  },
  '/de/br': {
    default: '/brandy',
  },
  '/de/gi': {
    default: '/gin',
    es: '/ginebra',
  },
  '/de/or': {
    default: '/orujo',
  },
  '/de/co': {
    default: '/cognac',
  },
  '/de/ro': {
    default: '/rum',
    es: '/ron',
    fr: '/rhum',
  },
  '/de/ar': {
    default: '/armagnac',
  },
  '/de/cm': {
    default: '/marc-de-champagne',
  },
  '/de/ap': {
    default: '/aperitivos',
  },
  '/de/dg': {
    de: '/verdauungsschnaps',
    en: '/digestifs',
    default: '/digestivo',
    fr: '/digestif',
  },
  '/de/mz': {
    default: '/mezcal',
  },
  '/de/ve': {
    de: '/wermut',
    en: '/vermouth',
    default: '/vermut',
    fr: '/vermouth',
  },
  '/de/ra': {
    default: '/ratafia',
  },
  '/de/li': {
    default: '/limoncello',
  },
  '/de/an': {
    de: '/anisschnaps',
    en: '/anise-liqueur',
    es: '/anis',
    fr: '/liqueur-d-anis',
    it: '/anisetta',
  },
  '/de/ot': {
    de: '/andere-likore',
    en: '/other-liqueurs',
    es: '/otros-licores',
    fr: '/autres-liqueurs',
    it: '/altri-liquori',
  },
  '/de/cw': {
    default: '/crema',
    fr: '/liqueur-de-creme',
    it: '/liquore-di-crema',
  },
  '/de/sh': {
    default: '/sidra-de-hielo',
  },
  '/de/sa': {
    default: '/sangria',
  },
  '/de/ao': {
    de: '/likor',
    en: '/liquor',
    es: '/aguardiente',
    fr: '/eau-de-vie',
    it: '/aquavite',
  },
  '/de/sk': {
    default: '/sake',
  },
  '/de/wg': {
    default: '/whisky-single-grain',
  },
  '/de/si': {
    default: '/sidra',
  },
  '/de/tw': {
    default: '/tennessee-whiskey',
  },
  generic: {
    de: '/produkt',
    en: '/product',
    es: '/producto',
    fr: '/produit',
    it: '/prodotto',
  },
  default: {
    de: '/wein',
    en: '/wine',
    es: '/vino',
    fr: '/vin',
    it: '/vino',
  },
}
